<template>
  <div>
    <header class="headerCom"> 
      <publicBreadCrumb  :breadList="breadList"/>
    </header>
    <!-- :style="{height:height}" -->
    <div class="new_container" id='setHeightDom' v-loading="loadFlag" :element-loading-text="loadTitle"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
      <div class="public-container">
        <div class="left-container">
          <div class="phone-top">
            <img class="message-img" src="@/assets/images/pub01.png" alt="">
            <div class="public-menu">
              <el-dropdown class="menu-dropdown" trigger="click" @command="handleCommand">
                <span class="public-menu-name el-dropdown-link">
                  {{serveName}}
                  <i class="el-icon-caret-bottom"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="item" v-for="item in serveList" :key="item.appId">{{item.name}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <img class="person" src="@/assets/images/pub02.png" alt="">
            </div>
            <div class="phone-bottom">
              <img class="keyboard-img" src="@/assets/images/pub03.png" alt="">
              <div class="add-menu-box">
                <div class='menu-popover' v-for="(item,index) in menuList" :key="index">
                  <!-- 一级菜单 -->
                  <div class="add-menu" :class="'menu-type'+menuList.length" @click="clickMenu(item,index)">
                    <template v-if="item.menuType==1">
                      <img v-if="item.checked" class="add-img" src="@/assets/images/pub07.png" alt="">
                      <img v-else class="add-img" src="@/assets/images/pub08.png" alt="">
                      <span :class="item.checked? 'menu-name':''">{{item.name}}</span>
                    </template>
                    <template v-else>
                      <img class="add-img" src="@/assets/images/pub04.png" alt="">
                      <span>{{item.name}}</span>
                    </template>
                  </div>
                  <!-- 二级菜单 -->
                  <div class="child-box" :class="'menu-type'+menuList.length" v-if="item.checked">
                    <div class="child-menu" v-for="(child,eq) in item.subButton" :key="eq"
                      @click="clickChild(child,index,eq)">
                      <span :class="child.checked? 'menu-name':''"> {{child.name}}</span>
                    </div>
                    <template v-if="item.subButton.length<5">
                      <div slot="reference" v-if="item.subButton.length>0" class="child-menu" @click='addChild(index)'>
                        <img class="add-child-img" src="@/assets/images/pub06.png" alt="">
                      </div>
                      <el-popconfirm v-else :title="'添加后“'+addTitle +'”菜单下设置的内容将会被删除！'" confirm-button-text='确定添加'
                        @confirm='addChild(index)'>
                        <div slot="reference" class="child-menu">
                          <img class="add-child-img" src="@/assets/images/pub06.png" alt="">
                        </div>
                      </el-popconfirm>
                    </template>
                    <div class="down-arrow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="add-menu-tip" v-if="noMenu">
            <img class="arrow-img" src="@/assets/images/pub05.png" alt="">
            请添加菜单
          </div>
          <div v-else>
            <div class="menu-con-top">
              <div class="baseSubTitle">
                <p></p>{{ruleForm.name}}
              </div>
              <div>
                <!-- <div class="hide-menu" @click="hideClick(ruleForm.hide)">
                  <img v-if="ruleForm.hide == -1" src="@/assets/images/pub10.png" alt="">
                  <img v-else src="@/assets/images/pub09.png" alt="">
                  <span>隐藏当前菜单</span>
                </div> -->
                <el-popconfirm title="是否确认删除本菜单？" @confirm='delMenu()'>
                  <el-button size="small" type="primary" slot="reference">删除菜单</el-button>
                </el-popconfirm>
              </div>
            </div>
            <el-form :model="ruleForm" :show-message='false' :rules="rules" ref="ruleForm" label-width="90px"
              class="demo-ruleForm">
              <el-form-item label="菜单名称" prop="name" class="form-item">
                <el-input style="width:280px" size="medium" :maxlength="maxlength" @focus="menuFocus"
                  v-model="ruleForm.name" @input="watchName" @blur="menuBlur">
                </el-input>
                <span class="input-tips">仅支持中英文和数字，字数不超过{{nameTips}}字母</span>
              </el-form-item>
              <template v-if="showOther">
                <el-form-item label="菜单内容" prop="type">
                  <el-radio-group v-model="ruleForm.type" @change='changeType'>
                    <el-radio label="click">发送消息</el-radio>
                    <el-radio label="view">跳转至网页链接</el-radio>
                    <el-radio label="miniprogram">跳转至小程序</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div class="tab-list" style="overflow:hidden" v-if="ruleForm.type=='click'">
                  <div class="reply-type" :class="msgTypeCurrent == index? 'childCur':''"
                    v-for="(item,index) in childTabs" :key="index" @click="clickChildTabs(index,item.val)">{{item.name}}
                  </div>
                </div>
                <el-form-item label="" v-if="ruleForm.type == 'click'">
                  <div class="words-box" v-if="msgTypeCurrent == 0">
                    <el-input class="words" type="textarea" placeholder="请输入文本" @input='watchText' v-model="textarea"
                      maxlength="1000"></el-input>
                    <div class="limit-box">
                      <div class="cur" @click="addLink">添加一个超链接</div>
                      <div>还可以输入{{wordsNum}}字，按下Enter健换行</div>
                    </div>
                  </div>
                  <div class="words-box" v-if="msgTypeCurrent == 1">
                    <div class="upload-link-img" v-if="ruleForm.mediaImgTextName">
                      <img class="link-img" :src="ruleForm.mediaImgTextUrl" alt="">
                      <img class="link-close" @click="delAudio('imgText')" src="@/assets/images/close.png" alt="">
                      <p class="link-title baseEllipsis">{{ruleForm.mediaImgTextName}}</p>
                      <div class="link-text baseLineEllipsis">{{ruleForm.mediaDec}}</div>
                      <div class="date">{{ruleForm.mediaImgTextUpdateTime | formateDate}}</div>
                    </div>
                    <div class="upload-link" v-else @click="showDialogClick(0)">
                      <i class="el-icon-plus"></i>
                      <p>选择图文素材</p>
                    </div>
                  </div>
                  <div class="words-box" v-if="msgTypeCurrent == 2">
                    <div class="upload-type-box" v-if="ruleForm.mediaUrl">
                      <img class="upload-type-img" :src="ruleForm.mediaUrl" alt="">
                      <img class="link-close" @click="delImg" src="@/assets/images/close.png" alt="">
                    </div>
                    <template v-else>
                      <div class="flex-type-img">
                        <div class="upload-type-img" @click="showDialogClick(1)">
                          <i class="el-icon-plus"></i>
                          <p>选择图片</p>
                        </div>
                        <!-- <div class="upload-type-img">
                          <i class="el-icon-plus"></i>
                          <p>本地上传</p>
                        </div> -->
                        <el-upload class="upload-type-img"
                          action="/api/dsicm-contact-platform/feign/file/wechat/upload/return" :show-file-list="false"
                          :data="{type:'image',appId:appId }" :on-error='upImgErr' :on-success="upImgSuccess"
                          :on-progress='upImg' :before-upload="beforeImgUpload">
                          <i class="el-icon-plus" style="display:block"></i>
                          <p>本地上传</p>
                        </el-upload>
                        <div class="upload-img-tip">请上传 PNG、JPG、JPEG类型图片，大小控制在10M以内</div>
                      </div>
                    </template>
                  </div>
                  <!-- 音频 -->
                  <div class="words-box" v-if="msgTypeCurrent == 3">
                    <div class="media-type-box">
                      <div class="media-item" v-if="ruleForm.mediaVoiceName">
                        <div>
                          <div class="name">{{ruleForm.mediaVoiceName}}</div>
                          <span>{{ruleForm.mediaVoiceUpdateTime | formateDate}}</span>
                        </div>
                        <img src="@/assets/images/audio.png" class="upload-img">
                        <img class="link-close" @click="delAudio('voice')" src="@/assets/images/close.png" alt="">
                      </div>
                      <template v-else>
                        <div class="media-type baseUploadIcon" @click="showDialogClick(2)">
                          <i class="el-icon-plus"></i>
                          <p>从素材库选择</p>
                        </div>
                        <div class="media-type baseUploadIcon">
                          <i class="el-icon-plus"></i>
                          <p>本地上传</p>
                          <div class="upload-img-tip">请上传时长小于60s的音频，支持mp3、wav类型视频，音频大小控制在5M以内</div>
                          <input type="file" id='voiceId' value="" @change="uploadVoice($event)">
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- 视频 -->
                  <div class="words-box" v-if="msgTypeCurrent == 4">
                    <div class="media-type-box">
                      <div class="media-item" v-if="ruleForm.mediaVideoName">
                        <div>
                          <div class="name">{{ruleForm.mediaVideoName}}</div>
                          <span>{{ruleForm.mediaVideoUpdateTime | formateDate}}</span>
                        </div>
                        <template v-if="ruleForm.mediaVideoUrl">
                          <i class="el-icon-video-play"></i>
                          <img class="upload-img" :src="ruleForm.mediaVideoUrl">
                        </template>
                        <img class="upload-img" v-else src="@/assets/images/default-video.png">
                        <img class="link-close" @click="delAudio('video')" src="@/assets/images/close.png" alt="">
                      </div>
                      <template v-else>
                        <div class="media-type baseUploadIcon" @click="showDialogClick(3)">
                          <i class="el-icon-plus"></i>
                          <p>从素材库选择</p>
                        </div>
                        <!-- <div class="media-type baseUploadIcon">
                          <i class="el-icon-plus"></i>
                          <p>本地上传</p>
                          <input type="file" id='videoId' @change="uploadVideo($event)">
                          <div class="upload-img-tip"> 请上传时长在10min内的视频，支持mp4、m4v类型视频，视频大小控制在200M以内</div>
                        </div> -->
                      </template>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="" v-if="ruleForm.type == 'view'">
                  <div class="words-box link">
                    <div class="link-tips">订阅者点击该菜单会跳到以下链接，您可自主添加链接</div>
                    <span>页面地址:</span>
                    <el-input class="link-url" size="medium" type="url" placeholder="http://.这里是其他链接.com"
                      v-model="ruleForm.url" maxlength="200" @input="watchLinkUrl">
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item label="" v-if="ruleForm.type == 'miniprogram'">
                  <div class="words-box link">
                    <div class="link-tips">
                      订阅者点击该子菜单会跳到以下小程序，若无可选择小程序请至对应公众号内进行关联</div>
                    <div>
                      <span class="label">小程序:</span>
                      <el-select class="select-self" v-model="ruleForm.appId" placeholder="请选择小程序" size="medium"
                        @change="changeMiniprogram">
                        <el-option v-for="item in wechatList" :key="item.appId" :label="item.name" :value="item.appId">
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <span class="label">页面地址:</span>
                      <el-input class="link-url" size="medium" type="text" placeholder="/pages/index/index"
                        v-model="ruleForm.pagePath" @input="watchPatch">
                      </el-input>
                    </div> 
                  </div>
                </el-form-item>
              </template>
            </el-form>
          </div>
        </div>
      </div>
      <template v-if="publicId">
        <imgtextDialog ref='imgTextCom' :publicId='publicId' @getImgTextObj='getImgTextObj' />
        <imgDialog ref='imgCom' :publicId='publicId' @getImgObj='getImgObj' />
        <audioDialog ref='audioCom' :publicId='publicId' @getVoiceObj='getVoiceObj' />
        <videoDialog ref='videoCom' :publicId='publicId' @getVideoObj='getVideoObj' />
      </template>
      <div class="baseFlexCenter">
        <el-button size="small" v-if="menuList.length>1" type="primary" @click='onSaveWord'>保存并发布</el-button>
        <el-popconfirm v-else title="您当前未配置任何内容，确定要发布吗？" @confirm='onSaveWordDel'>
          <el-button size="small" type="primary" slot="reference">保存并发布</el-button>
        </el-popconfirm>
      </div>
    </div>
  </div>
</template>

<script>
import { formateDate } from "../../commen/date.js";
import {
  wechatTypeNew,
  wechatType,
  wechatMenu,
  creatWechatMenu,
  delAllMenu
} from "@/api/customService.js";
import imgDialog from "./components/imgdialog.vue";
import videoDialog from "./components/videosdialog.vue";
import audioDialog from "./components/audiodialog.vue";
import imgtextDialog from "./components/imgtextdialog.vue";
import axios from "axios";
export default {
  filters: {
    formateDate(time) {
      time = time * 1000;
      return formateDate(time);
    }
  },
  components: {
    imgDialog,
    audioDialog,
    videoDialog,
    imgtextDialog
  },
  data() {
    return {
      breadList:[{name:'运营管理'},{name:'公众号配置'}],
      loadFlag: false,
      loadTitle: "",
      publicId: "", 
      keyWords: "",
      current: 0,
      maxlength: 8,
      dialogReply: false,
      textarea: "",
      wordsNum: 1000,
      noMenu: true,
      radio: 0,
      nameTips: "4个汉字和8个",
      rank: 1,
      addTitle: "菜单名称",
      curMenuIndex: 0, //选中的一级菜单
      curChildIndex: 0, //选中的二级菜单
      msgTypeCurrent: 0,
      showOther: true,
      linkUrl: false,
      serveName: "",
      appId: "",
      serveList: [],
      wechatList: [],
      childTabs: [
        { name: "文字消息", val: "text" },
        { name: "图文消息", val: "news" },
        { name: "图片消息", val: "image" },
        { name: "音频消息", val: "voice" },
        { name: "视频消息", val: "video" }
      ],
      menuList: [
        {
          name: "添加菜单",
          menuType: 2,
          subButton: []
        }
      ],
      ruleForm: {
        name: "菜单名称",
        type: "click",
        hide: -1,
        mediaUrl: null,
        url: "",
        appId: "",
        pagePath: ""
      },
      rules: {
        name: [{ required: true, message: "", trigger: "blur" }],
        type: [{ required: true, message: "", trigger: "change" }]
      },
      height: "500px",
      audioDuration: "",
      tableData: [],
      totalPage: "",
      listQuery: {
        current: 1,
        size: 10,
        replyType: "keyword",
        ruleName: ""
      },
      tableConfig: [
        {
          label: "序号",
          align: "center",
          prop: "ruleName",
          size: "mini"
        },
        {
          label: "机构名称",
          align: "center",
          prop: "publicId",
          size: "mini"
        },
        {
          label: "互医机构名称",
          align: "center",
          prop: "replyWay",
          size: "mini"
        },
        {
          label: "机构服务类型",
          align: "center",
          prop: "replyType",
          size: "mini"
        },
        {
          label: "医院等级",
          align: "center",
          prop: "updateTime",
          size: "mini"
        },
        {
          label: "状态",
          align: "center",
          prop: "createTime",
          size: "mini"
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 1);
                    }
                  }
                },
                "编辑回复"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 2);
                    }
                  }
                },
                "查看科室"
              )
            ]);
          }
        }
      ]
    };
  },
  sockets: {},
  mounted() {
    this.height = this.handleHeight() + "px";
    this.getWechatTypePub();
    this.getWechatType();
  },
  methods: {
    handleCommand(item) {
      this.serveName = item.name;
      this.appId = item.appId;
      this.publicId = item.publicId; 
      this.menuList = [];
      this.curMenuIndex = 0;
      this.msgTypeCurrent = 0;
      this.noMenu = true;
      this.ruleForm = this.$options.data().ruleForm;
      this.wechatMenu();
    },
    //获取公众号
    async getWechatTypePub() {
      let res = await wechatTypeNew({ type: 2, ascription: "dsicm" });
      this.serveList = res.data;
      this.appId = res.data[0].appId;
      this.publicId = res.data[0].publicId;
      this.serveName = res.data[0].name;
      this.wechatMenu();
    },
    //获取小程序
    async getWechatType() {
      let res = await wechatType({ type: 1 });
      this.wechatList = res.data;
    },
    // 获取微信菜单
    async wechatMenu() {
      let publicId = this.publicId;
      let res = await wechatMenu(publicId);
      let end = res.data ? res.data : [];
      if (end && end.length > 0) {
        let num = end.length;
        if (num < 1) {
          this.noMenu = true;
        } else {
          this.noMenu = false;
        }
        end.map(item => {
          item.menuType = 1;
          item.checked = false;
          if (!item.subButton) {
            item.subButton = [];
          }
        });
        end[0].checked = true;
        this.showMessage(end[0]);
        if (end[0].subButton.length > 0) {
          this.showOther = false;
        }
        if (num < 3) {
          end.push({ name: "添加菜单", menuType: 2, subButton: [] });
        }
      } else {
        end.push({ name: "添加菜单", menuType: 2, subButton: [] });
      }
      this.menuList = end;
    },
    // 添加|| 点击 一级菜单
    clickMenu(item, index) {
      //添加
      this.nameTips = "4个汉字和8个";
      if (item.menuType == 2) {
        let num = 0;
        if (this.menuList.length == 3) {
          num = 1;
          this.addTitle = "菜单名称";
        }
        let op = this.menuList.length - 1;
        this.menuList.splice(op, num, {
          name: "菜单名称",
          menuType: 1,
          checked: true,
          hide: -1,
          type: "click",
          msgType: "text",
          characters: "", //文本信息
          subButton: []
        });
        this.curMenuIndex = op;
        this.noMenu = false;
        this.showOther = true;
        this.ruleForm = {
          name: "菜单名称",
          type: "click",
          hide: -1,
          url: "",
          appId: "",
          pagePath: "",
          mediaUrl: "",
          msgType: "text",
          characters: "", //文本信息
          subButton: []
        };
        this.textarea = "";
        this.wordsNum = 1000;
        this.rank = 1;
        this.handleShowChild(op);
      } else {
        //点击
        this.handleComMenu(index, item);
      }
    },
    // 点击一级|| 删除默认选中一级
    handleComMenu(index, item) {
      this.rank = 1;
      this.curMenuIndex = index;
      this.showMessage(item);
      if (item.subButton.length > 0) {
        this.showOther = false;
      } else {
        this.showOther = true;
      }
      this.clearCheckedStatus(index);
      this.handleShowChild(index);
    },
    //添加二级菜单
    addChild(index) {
      this.nameTips = "8个汉字和16个";
      this.clearCheckedStatus(index);
      this.menuList[index].subButton.push({
        name: "菜单名称",
        checked: true,
        type: "click",
        hide: -1,
        msgType: "text",
        characters: ""
      });
      this.rank = 2;
      this.ruleForm = {
        name: "菜单名称",
        type: "click",
        hide: -1,
        msgType: "text",
        url: "",
        appId: "",
        characters: ""
      };
      this.showOther = true;
      this.curChildIndex = this.menuList[index].subButton.length - 1;
      //默认选中文字消息
      this.msgTypeCurrent = 0;
    },
    // 清空二级选中状态
    clearCheckedStatus(index) {
      this.menuList[index].subButton.map(item => {
        item.checked = false;
      });
    },
    // 点击二级菜单
    clickChild(child, index, eq) {
      this.nameTips = "8个汉字和16个";
      this.rank = 2;
      this.curChildIndex = eq;
      this.showOther = true;
      this.menuList[index].subButton.map((item, n) => {
        if (eq == n) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
      this.showMessage(child);
    },
    // 回显已存在信息
    showMessage(item) {
      this.addTitle = item.name;
      let mediaId = "";
      let characters = "";
      //图文
      let mediaImgTextName = "";
      let mediaImgTextUrl = "";
      let mediaImgTextUpdateTime = "";
      //图片
      let mediaUrl = "";
      //音频
      let mediaVoiceName = "";
      let mediaVocieUpdateTime = "";
      //视频
      let mediaVideoName = "";
      let mediaVideoUrl = "";
      let mediaVideoUpdateTime = "";
      // if (!item.type) {
      //   item.type = "click";
      // }
      this.textarea = item.characters ? item.characters : "";
      if (item.type == "click") {
        mediaId = item.mediaId;
        //处理消息选中 类型
        // if (!item.msgType) {
        //   item.msgType = "text";
        // }
        this.handelChooseMessType(item.msgType);
        if (item.msgType == "text") {
          characters = item.characters ? item.characters : "";
          this.textarea = characters;
          this.handleWordsNum();
        } else {
          this.textarea = "";
          this.wordsNum = 1000;
        }
        if (item.msgType == "news") {
          mediaImgTextName = item.mediaImgTextName || item.mediaName;
          mediaImgTextUrl = item.mediaImgTextUrl || item.mediaUrl;
          mediaImgTextUpdateTime =
            item.mediaImgTextUpdateTime || item.mediaUpdateTime;
        }
        if (item.msgType == "image") {
          mediaUrl = item.mediaUrl;
        }
        if (item.msgType == "voice") {
          mediaVoiceName = item.mediaVoiceName || item.mediaName;
          mediaVocieUpdateTime =
            item.mediaVocieUpdateTime || item.mediaUpdateTime;
        }
        if (item.msgType == "video") {
          mediaVideoName = item.mediaVideoName || item.mediaName;
          mediaVideoUrl = item.mediaVideoUrl || item.mediaUrl;
          mediaVideoUpdateTime =
            item.mediaVideoUpdateTime || item.mediaUpdateTime;
        }
      }
      this.ruleForm = {
        name: item.name,
        type: item.type,
        url: item.url,
        hide: item.hide,
        msgType: item.msgType,
        characters: characters,
        url: item.url,
        appId: item.appId,
        pagePath: item.pagePath,
        mediaId: mediaId,
        // 图文
        mediaImgTextName: mediaImgTextName,
        mediaImgTextUrl: mediaImgTextUrl,
        mediaImgTextUpdateTime: mediaImgTextUpdateTime,
        //图片
        mediaUrl: mediaUrl,
        //音频
        mediaVoiceName: mediaVoiceName,
        mediaVocieUpdateTime: mediaVocieUpdateTime,
        //视频
        mediaVideoUrl: mediaVideoUrl,
        mediaVideoName: mediaVideoName,
        mediaVideoUpdateTime: mediaVideoUpdateTime
      };
    },
    //选中消息类型
    handelChooseMessType(val) {
      if (val == "text") {
        this.msgTypeCurrent = 0;
      }
      if (val == "news") {
        this.msgTypeCurrent = 1;
      }
      if (val == "image") {
        this.msgTypeCurrent = 2;
      }
      if (val == "voice") {
        this.msgTypeCurrent = 3;
      }
      if (val == "video") {
        this.msgTypeCurrent = 4;
      }
    },
    //处理选中一级
    handleShowChild(index) {
      this.menuList.map((val, eq) => {
        if (eq == index) {
          val.checked = true;
        } else {
          val.checked = false;
        }
      });
    },
    // 同步输入菜单名称
    watchName(val) {
      let index = this.curMenuIndex;
      let childIndex = this.curChildIndex;
      if (this.rank == 1) {
        this.menuList[index].name = val;
        this.addTitle = val;
      } else {
        this.menuList[index].subButton[childIndex].name = val;
      }
    },
    menuFocus() {
      if (this.rank == 1) {
        this.maxlength = 8;
      } else {
        this.maxlength = 16;
      }
    },
    menuBlur() {
      if (this.ruleForm.name == "") {
        this.ruleForm.name = "菜单名称";
        let index = this.curMenuIndex;
        let childIndex = this.curChildIndex;
        if (this.rank == 1) {
          this.menuList[index].name = "菜单名称";
        } else {
          this.menuList[index].subButton[childIndex].name = "菜单名称";
        }
      }
    },
    //是否隐藏菜单
    hideClick(val) {
      if (val == 1) {
        this.ruleForm.hide = -1;
      } else {
        this.ruleForm.hide = 1;
      }
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].hide = this.ruleForm.hide;
      } else {
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].hide = this.ruleForm.hide;
      }
    },
    //删除菜单
    delMenu() {
      if (this.rank == 2) {
        this.menuList[this.curMenuIndex].subButton.splice(
          this.curChildIndex,
          1
        );
        if (this.menuList[this.curMenuIndex].subButton.length < 1) {
          this.showOther = true;
        }
        this.handleComMenu(this.curMenuIndex, this.menuList[this.curMenuIndex]);
      } else {
        this.menuList.splice(this.curMenuIndex, 1);
        let addFlag = this.menuList.some(item => {
          return item.menuType == 2;
        });
        if (!addFlag) {
          this.menuList.push({ name: "添加菜单", menuType: 2, subButton: [] });
        }
        if (this.menuList.length > 1) {
          this.handleComMenu(0, this.menuList[0]);
        } else {
          this.noMenu = true;
        }
      }
    },
    //选择菜单内容
    changeType(val) {
      if (this.rank == 1) {
        console.log("当前一级菜单：", this.menuList[this.curMenuIndex]);
        this.menuList[this.curMenuIndex].type = val;
        if (val == "click") {
          if (!this.menuList[this.curMenuIndex].msgType) {
            this.menuList[this.curMenuIndex].msgType = "text";
          }
          this.handelChooseMessType(this.menuList[this.curMenuIndex].msgType);
        } else if (val == "view") {
          // 如果已存在直接赋值，不存在做清空
          if (this.menuList[this.curMenuIndex].url) {
            this.ruleForm.url = this.menuList[this.curMenuIndex].url;
          } else {
            this.ruleForm.url = "";
          }
        }
      } else {
        console.log(
          "当前二级菜单：",
          this.menuList[this.curMenuIndex].subButton[this.curChildIndex]
        );
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].type = val;
        if (val == "click") {
          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].msgType = "text";
        }
      }
    },
    // 点击消息类型
    clickChildTabs(index, val) {
      this.msgTypeCurrent = index;
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].msgType = val;
      } else {
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].msgType = val;
      }
    },
    // 处理选中消息类型
    handelMsgType() {
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].msgType = "text";
      } else {
      }
    },
    showDialogClick(num) {
      if (num == 1) {
        this.$refs.imgCom.openDialog();
      } else if (num == 2) {
        this.$refs.audioCom.openDialog();
      } else if (num == 3) {
        this.$refs.videoCom.openDialog();
      } else {
        this.$refs.imgTextCom.openDialog();
      }
    },
    delImg() {
      this.ruleForm.mediaUrl = null;
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].mediaId = "";
      } else {
        this.menuList[this.curMenuIndex].subButton[this.curChildIndex].mediaId =
          "";
      }
      this.$forceUpdate();
    },
    //删除消息内容
    delAudio(type) {
      if (type == "imgText") {
        this.ruleForm.mediaImgTextName = null;
      }
      if (type == "voice") {
        this.ruleForm.mediaVoiceName = null;
      }
      if (type == "video") {
        this.ruleForm.mediaVideoName = null;
      }
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].mediaId = "";
        this.menuList[this.curMenuIndex].mediaName = null;
        this.menuList[this.curMenuIndex].mediaUrl = null;
        this.menuList[this.curMenuIndex].mediaUpdateTime = null;
        if (type == "imgText") {
          this.menuList[this.curMenuIndex].mediaImgTextUrl = null;
          this.menuList[this.curMenuIndex].mediaImgTextName = null;
          this.menuList[this.curMenuIndex].mediaImgTextUpdateTime = null;
        }
        if (type == "voice") {
          this.menuList[this.curMenuIndex].mediaVoiceName = null;
          this.menuList[this.curMenuIndex].mediaVocieUpdateTime = null;
        }
        if (type == "video") {
          this.menuList[this.curMenuIndex].mediaVideoName = null;
          this.menuList[this.curMenuIndex].mediaVideoUrl = null;
          this.menuList[this.curMenuIndex].mediaVideoUpdateTime = null;
        }
      } else {
        this.menuList[this.curMenuIndex].subButton[this.curChildIndex].mediaId =
          "";
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].mediaName = null;
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].mediaUrl = null;
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].mediaUpdateTime = null;

        if (type == "imgText") {
          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaImgTextUrl = null;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaImgTextName = null;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaImgTextUpdateTime = null;
        }
        if (type == "voice") {
          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVoiceName = null;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVocieUpdateTime = null;
        }
        if (type == "video") {
          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVideoName = null;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVideoUrl = null;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVideoUpdateTime = null;
        }
      }
      this.$forceUpdate();
    },
    //监听输入文本
    watchText(text) {
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].characters = text;
      } else {
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].characters = text;
      }
      this.handleWordsNum();
    },
    //选择图片
    getImgObj(data) {
      this.chooseImg(data);
    },
    upImg() {
      this.loadTitle = "正在上传，请您耐心等待...";
      this.loadFlag = true;
    },
    upImgErr(err) {
      console.log(err);
      this.loadFlag = false;
    },
    //是上传图片
    beforeImgUpload(file) {
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("请上传 PNG、JPG、JPEG格式图片!");
      }
      if (!isLt10M) {
        this.$message.error("图片大小不能超过 10M!");
      }
      return isJPG && isLt10M;
    },
    upImgSuccess(data) {
      this.loadFlag = false;
      if (data.code == 0) {
        this.chooseImg(data.data);
      } else {
        this.$message.error(data.message);
      }
    },
    chooseImg(data) {
      this.$set(this.ruleForm, "mediaUrl", data.url);
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].mediaId = data.media_id;
        this.menuList[this.curMenuIndex].mediaUrl = data.url;
      } else {
        this.menuList[this.curMenuIndex].subButton[this.curChildIndex].mediaId =
          data.media_id;
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].mediaUrl = data.url;
      }
    },
    //图文
    getImgTextObj(data) {
      this.chooseAudio(data, "imgText");
    },
    //音频
    getVoiceObj(data) {
      this.chooseAudio(data, "voice");
    },
    //视频
    getVideoObj(data) {
      this.chooseAudio(data, "video");
    },
    chooseAudio(data, type) {
      //图文
      if (type == "imgText") {
        this.$set(this.ruleForm, "mediaImgTextName", data.name);
        this.$set(this.ruleForm, "mediaImgTextUrl", data.cover_url);
        this.$set(this.ruleForm, "mediaImgTextUpdateTime", data.update_time);
        this.$set(this.ruleForm, "mediaDec", data.dec);
      }
      if (type == "voice") {
        //音频
        this.$set(this.ruleForm, "mediaVoiceName", data.name);
        this.$set(this.ruleForm, "mediaVocieUpdateTime", data.update_time);
      }
      if (type == "video") {
        //视频
        this.$set(this.ruleForm, "mediaVideoName", data.name);
        this.$set(this.ruleForm, "mediaVideoUrl", data.cover_url);
        this.$set(this.ruleForm, "mediaVideoUpdateTime", data.update_time);
      }
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].mediaId = data.media_id;
        //图文
        if (type == "imgText") {
          this.menuList[this.curMenuIndex].mediaImgTextName = data.name;
          this.menuList[this.curMenuIndex].mediaImgTextUpdateTime =
            data.update_time;
          this.menuList[this.curMenuIndex].mediaImgTextUrl = data.cover_url;
        }
        if (type == "voice") {
          //音频
          this.menuList[this.curMenuIndex].mediaVoiceName = data.name;
          this.menuList[this.curMenuIndex].mediaVocieUpdateTime =
            data.update_time;
        }
        if (type == "video") {
          //视频
          this.menuList[this.curMenuIndex].mediaVideoName = data.name;
          this.menuList[this.curMenuIndex].mediaVideoUpdateTime =
            data.update_time;
          this.menuList[this.curMenuIndex].mediaVideoUrl = data.cover_url;
        }
      } else {
        this.menuList[this.curMenuIndex].subButton[this.curChildIndex].mediaId =
          data.media_id;

        if (type == "imgText") {
          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaImgTextName = data.name;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaImgTextUrl = data.cover_url;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaImgTextUpdateTime = data.update_time;
        }

        if (type == "voice") {
          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVoiceName = data.name;
          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVocieUpdateTime = data.update_time;
        }
        if (type == "video") {
          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVideoName = data.name;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVideoUrl = data.cover_url;

          this.menuList[this.curMenuIndex].subButton[
            this.curChildIndex
          ].mediaVideoUpdateTime = data.update_time;
        }
      }
    },
    //上传音频
    uploadVoice(e) {
      let that = this;
      let files = e.target.files[0];
      let isAudio =
        files.type === "audio/mp3" ||
        files.type === "audio/mpeg" ||
        files.type === "audio/wav";
      let isLt5M = files.size / 1024 / 1024 < 5;
      if (!isAudio) {
        document.getElementById("voiceId").value = "";
        this.$message.error("请上传Mp3、wav格式音频！");
        return;
      }
      if (!isLt5M) {
        document.getElementById("voiceId").value = "";
        this.$message.error("音频大小不能超过 5M!");
        return;
      }
      var url = URL.createObjectURL(files);
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", _event => {
        let isTime60s = parseInt(audioElement.duration);
        if (isTime60s && isTime60s > 60) {
          document.getElementById("voiceId").value = "";
          this.$message.error("音频时长不能超过60秒!");
        } else {
          let param = new FormData();
          param.append("file", files);
          param.append("type", "voice");
          param.append("appId", that.appId);
          this.loadTitle = "正在上传，请您耐心等待...";
          this.loadFlag = true;
          axios
            .post(
              "/dsicm-contact-platform/feign/file/wechat/upload/return",
              param
            )
            .then(res => {
              this.loadFlag = false;
              if (res.data.success) {
                that.chooseAudio(res.data.data, "voice");
              } else {
                that.$message.error(res.data.message);
              }
            })
            .catch(err => {
              this.loadFlag = false;
              this.$message.error("上传失败");
            });
        }
      });
    },
    //上传视频
    uploadVideo(e) {
      let that = this;
      let files = e.target.files[0];
      let rule = ["video/swf", "video/mp4"];
      if (rule.indexOf(files.type) == -1) {
        document.getElementById("videoId").value = "";
        this.$message.error("请上传Mp4、m4v格式视频！!");
        return;
      }
      let isLt200M = files.size / 1024 / 1024 < 200;
      if (!isLt200M) {
        document.getElementById("videoId").value = "";
        this.$message.error("视频大小不能超过 200M!");
        return;
      }
      var url = URL.createObjectURL(files);
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", _event => {
        let isTime60s = parseInt(audioElement.duration);
        if (isTime60s && isTime60s > 60 * 10) {
          document.getElementById("videoId").value = "";
          this.$message.error("视频时长不能超过10分钟!");
        } else {
          let param = new FormData();
          param.append("file", files);
          param.append("type", "video");
          param.append("appId", that.appId);
          this.loadTitle = "正在上传，请您耐心等待...";
          this.loadFlag = true;
          axios
            .post(
              "/dsicm-contact-platform/feign/file/wechat/upload/return",
              param
            )
            .then(res => {
              this.loadFlag = false;
              if (res.data.success) {
                that.chooseAudio(res.data.data, "video");
              } else {
                that.$message.error(res.data.message);
              }
            })
            .catch(err => {
              this.loadFlag = false;
              this.$message.error("上传失败");
            });
        }
      });
    },
    // 监听输入网页地址
    watchLinkUrl(url) {
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].url = url;
      } else {
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].url = url;
      }
    },
    //选择小程序
    changeMiniprogram(id) {
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].appId = id;
      } else {
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].appId = id;
      }
    },
    //输入小程序页面路径
    watchPatch(path) {
      if (this.rank == 1) {
        this.menuList[this.curMenuIndex].pagePath = path;
      } else {
        this.menuList[this.curMenuIndex].subButton[
          this.curChildIndex
        ].pagePath = path;
      }
    },
    handleWordsNum() {
      if (1000 - this.textarea.length > 0) {
        this.wordsNum = 1000 - this.textarea.length;
      } else {
        this.wordsNum = 0;
      }
    },
    addLink() {
      let str = '<a href="你要放入的链接">起个名字</a>';
      if (1000 - this.textarea.length >= str.length) {
        this.textarea = this.textarea + str;
      }
      this.handleWordsNum();
    },
    onSaveWordDel() {
      let id = this.publicId;
      delAllMenu(id).then(res => {
        if (res.code == 0) {
          this.$message.success("发布成功！");
        }
      });
    },
    onSaveWord() {
      let strRegex =
        "^(https?|ftp|http)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]";
      let reg = new RegExp(strRegex);
      let flag = true;
      let params = {};
      let eq = null;
      let arr = JSON.parse(JSON.stringify(this.menuList));
      arr.map((item, index) => {
        if (!flag) {
          return;
        }
        //处理一级参数
        let obj = {
          name: item.name,
          hide: item.hide,
          subButton: []
        };
        let childObj = {};
        if (item.menuType == 2) {
          eq = index;
        }
        //删除添加菜单占位
        if (eq != null) {
          arr.splice(eq, 1);
          return;
        }
        //存在二级菜单时
        if (item.subButton && item.subButton.length > 0) {
          item.subButton.map(child => {
            if (!flag) {
              return;
            }
            childObj = {
              name: child.name,
              hide: child.hide,
              type: child.type
            };
            if (child.type == "click") {
              childObj.msgType = child.msgType;
              //文本
              if (child.msgType == "text") {
                childObj.characters = child.characters ? child.characters : "";
                if (
                  childObj.characters.trim().replace(/[\r\n]/g, "").length < 1
                ) {
                  flag = false;
                  this.$message.error(child.name + "菜单的内容不能为空！");
                }
              } else if (child.msgType == "imgae") {
                //图片
                childObj.mediaId = child.mediaId;
                childObj.mediaUrl = child.mediaUrl;
                if (!child.mediaId) {
                  flag = false;
                  this.$message.error(child.name + "菜单的图片不能为空！");
                }
              } else {
                if (!child.mediaId) {
                  let text = "图文";
                  flag = false;
                  if (child.msgType == "voice") {
                    text = "音频";
                  } else if (child.msgType == "video") {
                    text = "视频";
                  }
                  this.$message.error(
                    child.name + "菜单的" + text + "不能为空！"
                  );
                } else {
                  childObj.mediaId = child.mediaId;
                  if (child.msgType == "image") {
                    childObj.mediaUrl = child.mediaUrl;
                  }
                  if (child.msgType == "news") {
                    childObj.mediaName =
                      child.mediaImgTextName || child.mediaName;
                    childObj.mediaUrl = child.mediaImgTextUrl || child.mediaUrl;
                  }
                  if (child.msgType == "voice") {
                    childObj.mediaName =
                      child.mediaVoiceName || child.mediaName;
                  }
                  if (child.msgType == "video") {
                    childObj.mediaName =
                      child.mediaVideoName || child.mediaName;
                    childObj.mediaUrl = child.mediaVideoUrl;
                  }
                }
              }
            } else if (child.type == "view") {
              //网页
              childObj.url = child.url;
              if (!child.url) {
                flag = false;
                this.$message.error(child.name + "菜单的页面地址不能为空！");
              } else {
                if (!reg.test(child.url)) {
                  flag = false;
                  this.$message.error(child.name + "菜单的页面地址无效！");
                }
              }
            } else {
              //小程序
              childObj.appId = child.appId;
              childObj.pagePath = child.pagePath;
              if (!child.appId) {
                flag = false;
                this.$message.error(child.name + "菜单的小程序不能为空！");
              }
              if (child.appId && !child.pagePath) {
                flag = false;
                this.$message.error(child.name + "菜单的小程序路径不能为空！");
              }
            }
            obj.subButton.push(childObj);
          });
        } else {
          obj.type = item.type;
          if (!obj.type) {
            flag = false;
            this.$message.error(obj.name + "菜单的菜单内容不能为空！");
            return;
          }
          //消息
          if (item.type == "click") {
            obj.msgType = item.msgType;
            //文本
            if (item.msgType == "text") {
              obj.characters = item.characters ? item.characters : "";
              if (obj.characters.trim().replace(/[\r\n]/g, "").length < 1) {
                flag = false;
                this.$message.error(obj.name + "菜单的内容不能为空！");
              }
            } else if (item.msgType == "image") {
              //图片
              obj.mediaId = item.mediaId;
              obj.mediaUrl = item.mediaUrl;
              if (!item.mediaId) {
                flag = false;
                this.$message.error(obj.name + "菜单的图片不能为空！");
              }
            } else {
              if (!item.mediaId) {
                let text = "图文";
                flag = false;
                if (obj.msgType == "voice") {
                  text = "音频";
                } else if (obj.msgType == "video") {
                  text = "视频";
                }
                this.$message.error(obj.name + "菜单的" + text + "不能为空！");
              } else {
                obj.mediaId = item.mediaId;
                if (obj.msgType == "image") {
                  obj.mediaUrl = item.mediaUrl;
                }
                if (obj.msgType == "news") {
                  obj.mediaName = item.mediaImgTextName || item.mediaName;
                  obj.mediaUrl = item.mediaImgTextUrl || item.mediaUrl;
                }
                if (obj.msgType == "voice") {
                  obj.mediaName = item.mediaVoiceName || item.mediaName;
                }
                if (obj.msgType == "video") {
                  obj.mediaName = item.mediaVideoName || item.mediaName;
                  obj.mediaUrl = item.mediaVideoUrl;
                }
              }
            }
          } else if (item.type == "view") {
            //网页
            obj.url = item.url;
            if (!item.url) {
              flag = false;
              this.$message.error(obj.name + "菜单的页面地址不能为空！");
            } else {
              if (!reg.test(item.url)) {
                flag = false;
                this.$message.error(obj.name + "菜单的页面地址无效！");
              }
            }
          } else {
            //小程序
            obj.appId = item.appId;
            obj.pagePath = item.pagePath;
            if (!item.appId) {
              flag = false;
              this.$message.error(obj.name + "菜单的小程序不能为空！");
            }
            if (item.appId && !item.pagePath) {
              flag = false;
              this.$message.error(obj.name + "菜单的小程序路径不能为空！");
            }
          }
        }
        arr[index] = obj;
      });

      params.wechatMenuButtonList = arr;
      params.publicId = this.publicId;
      params.publicAppId = this.appId;
      if (flag) {
        this.loadTitle = "正在发布，请您耐心等待...";
        this.loadFlag = true;
        creatWechatMenu(params)
          .then(res => {
            this.loadFlag = false;
            if (res.code == 0) {
              this.$message.success("发布成功！");
              this.wechatMenu();
            }
          })
          .catch(err => {
            this.loadFlag = false;
          });
      }
    },
    hometHandel(item, type) {
      if (type == 1 || type == 2) {
        this.dialogReply = true;
      }
    },
    selectionChange() {}
  }
};
</script>  
<style lang="less" >
.el-popconfirm__main {
  margin: 10px 0;
}
.menu-popover {
  position: relative;
}
.el-popper .el-popconfirm__main {
  max-width: 210px;
}
</style>
<style lang="less" scoped>
.child-box {
  position: absolute;
  bottom: 60px;
  left: 0;
  border: 1px solid #d0d0d0;
  border-top: none;
  background: #f7f7f7;
  .down-arrow {
    position: absolute;
    width: 10px;
    height: 10px;
    background: #f7f7f7;
    bottom: -5px;
    left: 50%;
    margin-left: -5px;
    z-index: 2;
    transform: rotate(45deg);
    border: 1px solid #d0d0d0;
    border-top: none;
    border-left: none;
  }
}
.el-icon-video-play {
  color: #fff;
  font-size: 30px;
  position: absolute;
  top: 28px;
  right: 24px;
}
.hide-menu {
  cursor: pointer;
  display: inline-block;
  img {
    width: 14px;
    height: 14px;
    margin-right: 8px;
    display: inline-block;
    vertical-align: middle;
  }
  margin-right: 20px;
}
.public-menu-name {
  color: #fff;
}
.menu-dropdown {
  height: 36px;
  line-height: 36px;
  cursor: pointer;
}
.headerCom .text {
  padding-bottom: 20px;
}
.new_container {
  margin: 22px 16px;
  padding: 20px 25px;
  background: #fff;
  overflow: auto;
}
.public-container {
  display: flex;
}
.left-container {
  position: relative;
  width: 375px;
  height: 665px;
  border: 1px solid #e7e7e9;
  margin-right: 15px;
  .phone-top {
    height: 56px;
    background: #35363a;
    .message-img {
      width: 100%;
      display: block;
    }
  }
  .public-menu {
    display: flex;
    justify-content: center;
    height: 36px;
  }
}
.person {
  width: 18px;
  height: 18px;
  position: absolute;
  right: 16px;
  top: 29px;
}
.phone-bottom {
  position: absolute;
  width: 100%;
  height: 50px;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  background: #f7f7f7;
  cursor: pointer;
  .keyboard-img {
    width: 24px;
    height: 23px;
    margin: 0 10px;
  }
  .add-img {
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }
  .add-menu-box {
    display: flex;
  }
  .add-menu {
    height: 50px;
    display: flex;
    color: #333;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    border-left: solid 1px #d8d8d8;
  }
  .menu-name {
    color: #1a7bfc;
  }
  .menu-type1 {
    width: 328px;
  }
  .menu-type2 {
    width: 164px;
  }
  .menu-type3 {
    width: 109px;
  }
}
.child-menu {
  height: 48px;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #333;
  cursor: pointer;
  border-top: 1px solid #d0d0d0;
  .menu-name {
    color: #1a7bfc;
  }
  span {
    word-break: break-all;
    text-align: center;
  }
  .add-child-img {
    width: 16px;
    height: 16px;
  }
}
.right-container {
  position: relative;
  width: calc(100% - 392px);
  height: 665px;
  padding: 20px 30px 40px 58px;
  background: #f8fbff;
  .add-menu-tip {
    width: 240px;
    height: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -120px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(26, 123, 252, 0.05);
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    color: #1a7bfc;
    img {
      width: 22px;
      height: 22px;
      margin-right: 4px;
    }
  }
  .menu-con-top {
    display: flex;
    justify-content: space-between;
  }
  .input-tips {
    position: absolute;
    top: 32px;
    left: 0;
    font-size: 10px;
    color: #666;
  }
  .tab-list {
    padding-left: 88px;
    overflow: hidden;
  }
  .reply-type {
    margin: 0 32px 14px 0;
    color: #666;
    font-size: 12px;
    float: left;
    width: 80px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    border-radius: 4px;
    cursor: pointer;
  }
  .childCur {
    color: #fff;
    background: #1a7bfc;
  }
  .words-box {
    width: 100%;
    height: 380px;
    border-radius: 20px;
    border: 1px solid #d9d9d9;
    padding: 22px 25px;
    overflow: hidden;
    background: #fff;
  }
  .words.el-textarea {
    padding: 0;
    height: 290px;
    margin-bottom: 20px;
    /deep/.el-textarea__inner {
      height: 100%;
      border: none;
      resize: none;
      padding: 0;
    }
  }
  .limit-box {
    display: flex;
    justify-content: space-between;
    color: #333;
    line-height: 17px;
    .cur {
      color: #1a7bfc;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .link {
    margin-top: 7px;
    height: 400px;
  }
  .link-url {
    width: 280px;
    margin: 18px 20px;
  }
  .link-tips {
    line-height: 16px;
  }
  .label {
    display: inline-block;
    width: 65px;
  }
  .upload-link {
    width: 260px;
    height: 242px;
    border: solid 1px #e5e5e5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #666;
    border-radius: 15px;
    .el-icon-plus {
      font-size: 35px;
      color: #666;
    }
  }
  .upload-link-img {
    width: 260px;
    height: 242px;
    background: #f5f5f5;
    position: relative;
    border: solid 1px #e5e5e5;
    border-radius: 15px;
    color: #333;
    .link-img {
      border-radius: 15px 15px 0px 0px;
      width: 100%;
      height: 118px;
      display: block;
    }
    .link-title {
      font-size: 14px;
      line-height: 14px;
      margin: 14px 16px 10px;
    }
    .link-text {
      line-height: 22px;
      margin: 0 16px 10px;
    }
    .date {
      line-height: 12px;
      margin-left: 16px;
    }
  }
  .select-self {
    margin: 18px 0 0 20px;
    width: 280px;
  }
}
.baseFlexCenter {
  padding: 60px 0;
  text-align: center;
}
.link-close {
  cursor: pointer;
  width: 20px;
  height: 20px;
  position: absolute;
  right: -10px;
  top: -10px;
}
.flex-type-img {
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  .upload-type-img {
    position: relative;
    width: 80px;
    height: 80px;
    border: solid 1px #e5e5e5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #666;
    border-radius: 15px;
    margin-right: 20px;
  }
  .el-icon-plus {
    font-size: 25px;
    color: #666;
  }
  p {
    line-height: 24px;
    color: #666;
  }
  .upload-img-tip {
    color: #999;
    font-size: 12px;
  }
}
.upload-type-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  .upload-type-img {
    width: 80px;
    height: 80px;
    border-radius: 15px;
  }
}
.baseUploadIcon {
  cursor: pointer;
  position: relative;
  border: dashed 1px #e5e5e5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #666;
  border-radius: 15px;
  margin-right: 20px;
  .upload-img-tip {
    position: absolute;
    width: 100%;
    line-height: 17px;
    bottom: -65px;
    color: #999;
    text-align: left;
    font-size: 12px;
  }
}
.media-type-box {
  display: flex;
  .el-icon-plus {
    font-size: 28px;
    color: #666;
  }
  p {
    margin-top: 10px;
    line-height: 12px;
    color: #666;
  }
}
.media-type {
  width: 186px;
  height: 86px;
  input {
    width: 100%;
    height: 86px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
}
.media-item {
  width: 186px;
  height: 86px;
  display: flex;
  justify-content: space-between;
  padding: 20px 14px;
  background: #f5f5f5;
  border-radius: 15px;
  font-size: 14px;
  color: #333333;
  align-items: center;
  position: relative;
  margin-right: 16px;
  .upload-img {
    width: 52px;
    height: 52px;
    border-radius: 4px;
    display: block;
  }
  .name {
    max-width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
